import { selectors } from 'modules/common';
import { FC, memo } from 'react';

import FieldEntry from '../../../../../components/FieldEntry';
import PreviewSection from '../../../../../components/previewSection/PreviewSection';
import SectionSeparator from '../../../../../components/SectionSeparator/SectionSeparator';
import PostalAddressField from './components/PostalAddressField';
import PostalAddressFieldsWrap from './components/PostalAddressFieldsWrap';
import { messages } from './PostalAddressSection.messages';
import { PostalAddressSectionProps } from './PostalAddressSection.types';

const PostalAddressSection: FC<PostalAddressSectionProps> = memo((props) => {
    const { contactData } = props;

    const hasFilledValue =
        contactData.address.country ||
        contactData.address.city ||
        contactData.address.region ||
        contactData.address.street ||
        contactData.address.postCode;

    if (!hasFilledValue) {
        return null;
    }

    return (
        <>
            <PreviewSection header={messages.header}>
                <PostalAddressFieldsWrap>
                    {contactData.address.country && (
                        <PostalAddressField.Small>
                            <FieldEntry title={messages.country} value={contactData.address.country} />
                        </PostalAddressField.Small>
                    )}

                    {contactData.address.city && (
                        <PostalAddressField.Small>
                            <FieldEntry title={messages.cityTown} value={contactData.address.city} />
                        </PostalAddressField.Small>
                    )}

                    {contactData.address.region && (
                        <PostalAddressField.Small>
                            <FieldEntry title={messages.stateProvince} value={contactData.address.region} />
                        </PostalAddressField.Small>
                    )}

                    {(contactData.address.street || contactData.address.postCode) && (
                        <PostalAddressField.Halfwidth>
                            <FieldEntry
                                title={messages.address}
                                value={selectors.ui.getDisplayAddress(
                                    contactData.address.street,
                                    contactData.address.postCode
                                )}
                            />
                        </PostalAddressField.Halfwidth>
                    )}
                </PostalAddressFieldsWrap>
            </PreviewSection>

            <SectionSeparator />
        </>
    );
});

export default PostalAddressSection;
